import type { GA4Event } from '@/typings/base'
import { isElectron } from '@/utils/common'
import { IS_INTL } from '@/constants/global'
import { useGlobalStore } from '@/stores/global'

const consentConfig = () => {
  if (!isElectron() && IS_INTL) {
    // @ts-ignore
    gtag('consent', 'default', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'denied'
    })
  }
}

const consentGranted = async () => {
  if (!isElectron() && IS_INTL) {
    // @ts-ignore
    gtag('consent', 'update', {
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      analytics_storage: 'granted'
    })
  }
}

const initUserInfo = (userProperties: any) => {
  if (userProperties.nickname) {
    // @ts-ignore
    window.dataLayer.push(userProperties)
    console.log('initUserProperties', userProperties)
  }
}

const setUserId = (userId: string) => {
  // @ts-ignore
  window.gtag('set', 'user_properties', {user_id: userId})
}

const setClientId = (clientId: string) => {
  // @ts-ignore
  window.gtag('set', 'client_id', clientId)
}

function getEventId() {
  // @ts-ignore
  const google_tag_manager = window.google_tag_manager
  if (google_tag_manager && google_tag_manager[import.meta.env.VITE_GTM_ID]) {
    const gtmData = google_tag_manager[import.meta.env.VITE_GTM_ID].dataLayer.get('gtm')
    if (gtmData) {
      return gtmData.start + '.' + gtmData.uniqueEventId
    }
  }
  return ''
}

const logEventGA4 = async (eventName: GA4Event | string, eventParams: any, userProperties: any) => {
  if (!userProperties.nickname) return

  const globalStore = useGlobalStore()

  console.info('Track event', eventName, eventParams, userProperties)

  const triggerData = globalStore.triggerData
  if (triggerData) {
    eventParams.ltr = triggerData.trigger
    eventParams.ltrid = triggerData.trid
  }

  const fbc = document.cookie
    .split('; ')
    .find((row) => row.startsWith('_fbc='))
    ?.split('=')[1]
  const gcl = document.cookie
    .split('; ')
    .find((row) => row.startsWith('_gcl_aw='))
    ?.split('=')[1]

  if (fbc || gcl) {
    // 将广告ID作为user_id
    eventParams.user_id = fbc?.split('.').pop() || gcl?.split('.').pop()
    setUserId(eventParams.user_id)
  }

  const data = {
    event: eventName,
    platform: isElectron() ? 'client' : 'web',
    look_event: 'true',
    event_id: eventParams.event_id || getEventId(),
    look_version: import.meta.env.VITE_VERSION,
    ...eventParams,
    // 适配服务端报送
    user_data: userProperties
  }

  if (isElectron()) {
    // @ts-ignore
    data.app_version = `${globalStore.appVersion.substring(
      0,
      globalStore.appVersion.lastIndexOf('.')
    )}.x`
  }
  // @ts-ignore
  window.dataLayer.push(data)
  console.info(`Event sent(web): ${eventName}`, data)
}

export default {
  logEvent: logEventGA4,
  consentConfig,
  consentGranted,
  initUserInfo,
  setUserId,
  setClientId
}
